import { Button, Descriptions, Modal, Space, Statistic } from "antd";

export interface CommissionSummaryData {
  commissionIndex: number;
  roundLimit: number;
  commissionMagic: number;
  totalMagic: number;
  materialCount: number;
  recipeCount: number;
  consumableCount: number;
  addedMaterialCount: number;
  addedRecipeCount: number;
  addedConsumableCount: number;
}

export interface CommissionSummaryModalProps {
  open: boolean;
  data?: CommissionSummaryData;
  isLastCommission: boolean;
  onNext: () => void;
}

export function CommissionSummaryModal({
  open,
  data,
  isLastCommission,
  onNext,
}: CommissionSummaryModalProps) {
  return (
    <Modal
      open={open}
      title={data ? `第 ${data.commissionIndex} 个委托结算` : "委托结算"}
      centered
      width={720}
      closable={false}
      maskClosable={false}
      destroyOnHidden
      footer={(
        <Button type="primary" size="large" onClick={onNext}>
          {isLastCommission ? "游戏结束" : "下一个委托"}
        </Button>
      )}
    >
      {data && (
        <Space direction="vertical" size={16} style={{ width: "100%" }}>
          <Space size={24} wrap>
            <Statistic title="本委托魔力" value={data.commissionMagic} />
            <Statistic title="当前总魔力" value={data.totalMagic} />
            <Statistic title="委托轮数" value={data.roundLimit} suffix="轮" />
          </Space>
          <Descriptions size="small" bordered column={3}>
            <Descriptions.Item label="材料库">{data.materialCount}</Descriptions.Item>
            <Descriptions.Item label="配方">{data.recipeCount}</Descriptions.Item>
            <Descriptions.Item label="辅料">{data.consumableCount}</Descriptions.Item>
            <Descriptions.Item label="新增原料">{data.addedMaterialCount}</Descriptions.Item>
            <Descriptions.Item label="新增配方">{data.addedRecipeCount}</Descriptions.Item>
            <Descriptions.Item label="新增辅料">{data.addedConsumableCount}</Descriptions.Item>
          </Descriptions>
        </Space>
      )}
    </Modal>
  );
}
